'use strict';

import { setHistoryInstance } from './appState.js';
import { lmAppStorage } from './lmAppStorage.js';
import { setUrlParam, getUrlParam } from './urlTools.js';
import { scrollAnimate } from './Scrolls.js';

// History
const lmHistoryInstance = (function() {

    var newHistoryReplaceStateUrl = undefined;
    var getNewHistoryReplaceStateUrl = function() {
        return newHistoryReplaceStateUrl;
    };
    function lmHistoryAPI(conf) {
        const self = this;

        self.list = {};
        self.isInit = false;

        self.silentPopStateHandler = false;
        self.disablePopStateHandler = false;
        self.afterPopstate = null;

        self.debug = false;
        self.currentPosition = Number(lmAppStorage.history.get('historyPosition')) || 0;
        self.currentState = history.state || {};
        self.originalState = $.extend(true, {}, self.currentState);
        self.currentUrl = getNewHistoryReplaceStateUrl() || location.href.toString();
        self.startUrl = getNewHistoryReplaceStateUrl();

        self.currentUrl = setUrlParam('uuRename', false, false, self.startUrl);
        self.startUrl = setUrlParam('uuRename', false, false, self.startUrl);


        self.isReady = false;
        self.readyResolve = null;
        // @ts-ignore
        self.readyPromise = new Promise((resolve, reject) => {
            if (self.isReady) {
                resolve(null);
                return;
            }
            self.readyResolve = resolve;
        }).then(() => {
            self.isReady = true;
        });

        self.toggleUrls = function (params, value = null) {
            self.currentUrl = setUrlParam(params, value, false, self.currentUrl);
            self.startUrl = setUrlParam(params, value, false, self.startUrl);
        };

        self.getCurrentUrl = function () {
            //console.log('getCurrentUrl', self.currentUrl);
            return self.currentUrl || location.href.toString();
        };

        self.init = function () {
            self.currentState = $.extend(true, self.currentState, self.getStateCurrent(), {
                popv2: true,
                position: self.currentPosition
            });

            // izveidojam popstate event handler
            var popstate = function (event) {
                event.stopPropagation();


                if (event.originalEvent instanceof PopStateEvent && event.originalEvent.state) {
                    const state = event.originalEvent.state;

                    // Pārbaudām, vai šis ir mūsu mākslīgi iestumtais starpsolis
                    if (state && state.forceReload) {
                        // Droši nokopējam pilnīgi visu esošo stāvokli jaunā objektā un nodzēšam tikai mūsu zīmogu, lai tas vairs neietekmētu nākamo salīdzināšanu
                        const newState = { ...state };
                        delete newState.forceReload;
                        window.history.replaceState(newState, '');
                        window.location.reload();
                        return;
                    }

                    if (typeof state.popv2 != 'undefined') {
                        if (!self.disablePopStateHandler) {
                            self.handlePopState(state);
                        }
                        return;
                    }
                }
            };

            $(window).off('popstate.popv2').on('popstate.popv2', popstate);
            self.replaceState(self.currentState, '', self.startUrl);

            self.isInit = true;
        };

        self.initRefresh = function () {
            let count = 0;
            let urlState = self.getStateFromUrl();
            let offParams = [];

            try {
                $.each(self.list, function (id, data) {
                    // @ts-ignore
                    if (data.goBackOnRefresh) {
                        if (self.currentState[id] === null) {
                            //console.log('self.originalState[id]', id, self.originalState[id]);
                            if (self.originalState[id] === null || self.originalState[id] === undefined) {
                                //console.log('offParams', id);
                                offParams.push(id);
                            } else if (urlState[id] !== self.currentState[id]) {
                                let countAdd = 1;
                                try {
                                    // te atrodam un izsaucam spec callback lai zinam par cik soļiem iet atpakaļ priekš pin;
                                    // @ts-ignore
                                    if (typeof data.refreshCallback == 'function') {
                                        // @ts-ignore
                                        countAdd = data.refreshCallback(urlState[id], self.currentState[id]);
                                    }
                                } catch (e) {

                                }
                                count += countAdd;
                                if (countAdd) {
                                    offParams.push(id);
                                }
                            }
                        }
                    }
                });
            } catch (e) {
                console.error('Error in initRefresh', e);
            }

            //console.log('offParams', offParams);
            //console.log('count', count);

            // vienkārši aiztaisam bez back tos kas nav atrasti;
            try {
                if (offParams.length) {
                    var prevUrl = self.getCurrentUrl();
                    var url = new URL(self.getCurrentUrl());
                    var searchParams = url.searchParams;
                    // @ts-ignore
                    $.each(offParams, function (idx, id) {
                        searchParams.delete(id);
                    });
                    self.currentUrl = self.startUrl = url.toString();
                    if (prevUrl != self.currentUrl) {
                        self.replaceState(self.currentState, '', self.startUrl);
                    }
                }
            } catch (e) {
                console.error('Error in initRefresh', e);
            }

            if (count) {
                self.afterPopstate = function () {
                    //self.isReady = true;
                    //console.log('afterPopstate ');
                    self.readyResolve();
                    return false;
                };
                history.go(0 - count);
            } else {
                //self.isReady = true;
                self.readyResolve();
            }
        };

        self.getStateCurrent = function () {
            var state = {};

            $.each(self.list, function (id, data) {
                // @ts-ignore
                if (typeof data.checkCallback == 'function') {
                    // @ts-ignore
                    state[id] = data.checkCallback(data.value);
                    return;
                }
                // @ts-ignore
                state[id] = data.value || null;
            });

            return state;
        };

        self.getStateFromUrl = function () {
            var state = {};
            var url = new URL(self.getCurrentUrl());
            var searchParams = url.searchParams;

            // @ts-ignore
            $.each(self.list, function (id, data) {
                let value = searchParams.get(id);

                // @ts-ignore
                state[id] = value === null ? null : (value === '' ? true : value);
            });

            return state;
        };


        self.registerDefParams = function (ids) {
            $.each(ids, function (i, id) {
                setItemData(id, {
                    value: null,
                    disableNext: true,
                    goBackOnRefresh: true
                }, true);
            });
        };

        self.add = function (id, data) {
            setItemData(id, data || {}, true);
        };

        var setItemData = function (id, data, init) {
            if (!self.list[id]) {
                self.list[id] = {};
            }

            self.list[id].value = data.value || (init ? null : false);

            if (init || typeof data.backCallback != 'undefined') {
                self.list[id].backCallback = data.backCallback || null;
            }

            if (init || typeof data.nextCallback != 'undefined') {
                self.list[id].nextCallback = data.nextCallback || null;
            }

            if (init || typeof data.checkCallback != 'undefined') {
                self.list[id].checkCallback = data.checkCallback || null;
            }

            if (init || typeof data.refreshCallback != 'undefined') {
                self.list[id].refreshCallback = data.refreshCallback || null;
            }

            if (init || typeof data.disableNext != 'undefined') {
                self.list[id].disableNext = data.disableNext || false;
            }
            if (init || typeof data.goBackOnRefresh != 'undefined') {
                self.list[id].goBackOnRefresh = data.goBackOnRefresh || false;
            }
        };

        self.setNewStateData = function () {
            var state = $.extend(true, {}, self.currentState);
            var url = new URL(self.getCurrentUrl());
            var searchParams = url.searchParams;

            $.each(self.list, function (id, data) {
                // @ts-ignore
                if (typeof data.value == 'undefined') {
                    return;
                }
                // @ts-ignore
                state[id] = data.value === null ? null : (data.value === '' ? true : data.value);

                if (state[id] !== null) {
                    searchParams.set(id, state[id] !== true ? state[id] : '');
                } else {
                    searchParams.delete(id);
                }
            });

            self.currentState = state;
            self.currentUrl = url.toString();
        };

        self.push = function (id, data) {
            // init current state ja tas vēl nav izdarīts;
            if (!self.isInit) {
                self.init();
            }

            if (!data) {
                data = {};
            }
            if (typeof data.value === 'undefined') {
                data.value = true;
            }

            //console.log('push ', id);

            self.currentPosition++;
            lmAppStorage.history.set('historyPosition', self.currentPosition);
            self.currentState.position = self.currentPosition;
            self.currentState.popv2 = true;

            setItemData(id, data, false);
            self.setNewStateData();

            history.pushState(self.currentState, '', self.getCurrentUrl());
        };


        self.go = function (i) {
            if (i == -1) {
                history.back();
                return;
            }
            history.go(i);
        };

        self.back = function () {
            history.back();
        };

        self.goSilent = function (i) {
            self.silentPopStateHandler = true;

            history.go(i);
        };

        self.handlePopState = function (state) {
            var isNext = false;
            if (state.position < self.currentPosition) {
                // Handle back navigation
            } else if (state.position > self.currentPosition) {
                isNext = true;
                // Handle forward navigation
            } else {
                if (self.afterPopstate) {
                    //console.log('afterPopstate called ');
                    if (!self.afterPopstate()) {
                        self.afterPopstate = null;
                    }
                }
                return false;
            }

            //console.log('handlePopState called ', state);
            // atzīmējam jauno position;
            self.currentPosition = state.position;
            lmAppStorage.history.set('historyPosition', self.currentPosition);
            self.currentState = $.extend(true, {}, state);

            var changes = {};
            var allAvailable = true;

            $.each(self.list, function (id, data) {
                let result = null;
                let check = state[id] || null;
                // @ts-ignore
                if (typeof data.checkCallback == 'function') {
                    // @ts-ignore
                    result = data.checkCallback(data.value);
                }

                //console.log('check !== result', check, result);
                if (check !== result) {
                    // @ts-ignore
                    changes[id] = {
                        from: result,
                        to: check
                    };

                    // @ts-ignore
                    if (!(isNext ? (data.nextCallback ? true : false) : (data.backCallback ? true : false))) {
                        allAvailable = false;
                    }
                }
                // @ts-ignore
                self.list[id].value = check;
            });

            if (!allAvailable) {
                setTimeout(function () {
                    history.go(-1);
                }, 0);
                return false;
            }
            if (!self.silentPopStateHandler) {
                $.each(changes, function (id, change) {
                    // @ts-ignore
                    let callback = isNext ? self.list[id].nextCallback : self.list[id].backCallback;
                    callback(change);
                });
            }

            if (self.afterPopstate) {
                if (!self.afterPopstate()) {
                    self.afterPopstate = null;
                }
            }
        };

        self.replaceState = function(state, u, url) {
            //console.error('replaceState called', url);
            history.replaceState(state || {}, u || '', url);
        };
    }

    return new lmHistoryAPI();
})();
setHistoryInstance(lmHistoryInstance);


lmHistoryInstance.registerDefParams([
    'cht2', 'cht1', 'pin2', 'pin1', 'pincreate', 'pininput', 'cityselectfav', 'cityaddfav', 'citylist', 'wmmcalendar',
    'dialog', 'opt', 'newconversation'
]);
lmHistoryInstance.add('scrolltohash', {
    value: getUrlParam('scrolltohash') ?? null,
    backCallback: function (change) {
        setTimeout(function () { scrollAnimate($(window).scrollTop(), change.from, 500); }, 50);
    },
    checkCallback: function (value) {
        return $(window).scrollTop() != value ? value : false;
    },
    disableNext: true,
    goBackOnRefresh: false
});

export { lmHistoryInstance };